// eslint-disable-next-line import/prefer-default-export
export const SurveyFormat = {
  CLASSIC: 'CLASSIC' as const,
  CONVERSATIONAL: 'CONVERSATIONAL' as const,
  ONE_QUESTION_AT_A_TIME: 'ONE_QUESTION_AT_A_TIME' as const,
  SYMPTOM_TRACKING: 'SYMPTOM_TRACKING' as const,
} as const;
